import "./style.css";
import CVContainer from "../common/CVContainer/CVContainer";
import { VOICEMAIL } from "../../constants/constants";

const Voicemail = () => {
  return <CVContainer type={VOICEMAIL} />;
};

export default Voicemail;
